export const iconFontAwesomeFoodBeverageEgg = (
	<i className="fa-solid fa-egg"></i>
);
